export const buildTimeUtilizationQueryParams = ({
  user_ids,
  department_ids,
  years,
  sum_mode,
} = {}) => {
  const params = new URLSearchParams()

  if (user_ids?.length > 0) {
    user_ids.forEach((userId) => {
      if (userId) {
        params.append('user_ids[]', userId)
      }
    })
  }

  if (department_ids?.length > 0) {
    department_ids.forEach((departmentId) => {
      if (departmentId) {
        params.append('department_ids[]', departmentId)
      }
    })
  }

  if (years?.length > 0) {
    years.forEach((year) => {
      if (year) {
        params.append('years[]', year)
      }
    })
  }

  params.append('sum_mode', Number(sum_mode))

  return params.toString()
}
